import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'
import moment from 'moment'

export const columnData = (item) => {
  const userLangs = Array.isArray(item?.user?.languages) ? item.user.languages : []
  const allLanguages = userLangs
    .map((l) => l.language?.name)
    .filter(Boolean)
    .join('\n')

  const allLevels = userLangs
    .map((l) => l.level)
    .filter(Boolean)
    .join('\n')
  const formatDate = (date) => moment(date).format('DD/MM/YYYY')
  const fullName = [item?.user?.first_name, item?.user?.last_name].filter(Boolean).join(' ')
  const resignActiveBadgeStyle = {
    padding: '2px 8px',
    borderRadius: '12px',
    fontSize: '10px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  }
  return [
    fullName,
    item?.user.email,
    item?.user.identity_card,
    item?.user?.activity?.name,
    item?.user?.department[0]?.name,
    item?.user?.function?.name,
    allLanguages,
    allLevels,
    item?.user?.office_location,

    item?.resign_type ? (item.resign_type === 'involuntary' ? 'Jo-Vullnetare' : 'Vullnetare') : '',
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {item?.is_active ? (
        <span
          style={{
            ...resignActiveBadgeStyle,
            backgroundColor: '#32cd32',
            color: 'white',
            boxShadow: '0 2px 4px rgba(50, 205, 50, 0.3)'
          }}
        >
          Active
        </span>
      ) : (
        <span
          style={{
            ...resignActiveBadgeStyle,
            backgroundColor: '#9e9e9e',
            color: 'white',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.12)'
          }}
        >
          Jo aktiv
        </span>
      )}
    </div>,
    item?.created_date ? formatDate(item.created_date) : '',
    item?.resign_day ? formatDate(item.resign_day) : '',
    item?.last_date_on_work ? formatDate(item.last_date_on_work) : '',
    <Link to={`resignsDetails/${item._id}`}>
      <Button style={{ marginLeft: '5px' }} outline className='mb-1' color='warning' type='button'>
        <span>Detajet</span>
      </Button>
    </Link>
  ]
}
